import {UserInfo} from "../models/utilTypes";
import {AuthRepository, IAuthRepository} from "../infrastructure/reposirory/authRepository";

export interface IAuthService {
  signIn(email: string, password: string): Promise<string>;
  signUp(email: string, password: string, username: string): Promise<UserInfo>;
  signOut(): Promise<void>;
  isLogin(dispatch: any): void;
  resetEmail(email:string): Promise<void>;
}

export class AuthService implements IAuthService {

  private static _instance: AuthService;
  private readonly _authRepository: IAuthRepository;

  // テストしやすいようにDIする形にしている
  constructor() {
    this._authRepository = AuthRepository.instance;
  }

  static get instance() {
    if(!this._instance){
      this._instance = new AuthService();
    }
    return this._instance;
  }

  async signIn(email: string, password: string) {
    return await this._authRepository.signIn(email, password);
  }

  async signUp(email: string, password: string, username:string) {
    return await this._authRepository.signUp(email, password, username);
  }

  async signOut() {
    await this._authRepository.signOut();
  }

  isLogin(dispatch: any) {
    return this._authRepository.isLogin(dispatch);
  }

  async resetEmail(email:string) {
    await this._authRepository.resetEmail(email);
  }
}
